import { useEffect, useRef, useState } from 'react';

const useKwaiPlayer = () => {
  const [player, setPlayer] = useState(null);

  useEffect(() => {
    const loadPlayer = async () => {
      const { default: KwaiPlayerReact, KwaiPlayer } = await import(
        '@ks-video/kwai-player-web/react'
      );
      const StreamlakeControls = (
        await import('@ks-video/kwai-player-plugin-streamlake-controls')
      ).default;
      const ChromeControlsPlugin = KwaiPlayer.getRegisteredPlugin().find(
        (p) => p.label == 'ChromeControlsPlugin'
      );
      if (ChromeControlsPlugin) {
        KwaiPlayer.deregister(ChromeControlsPlugin);
      }
      //@ts-ignore
      if (KwaiPlayer.getRegisteredPlugin().indexOf(StreamlakeControls) === -1) {
        //@ts-ignore
        KwaiPlayer.register(StreamlakeControls);
      }
      setPlayer(KwaiPlayerReact);
    };
    loadPlayer();
  }, []);

  return player;
};
export default useKwaiPlayer;
